<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-demo__news">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item>
                    <el-input v-model="dataForm.name" placeholder="请输入残协名称或专职委员" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
                      @sort-change="dataListSortChangeHandle" style="width: 100%">
                <el-table-column prop="id" label="ID" header-align="center" align="center"></el-table-column>
                <el-table-column prop="activityName" label="活动名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="member" label="参加人员" header-align="center" align="center"></el-table-column>
                <el-table-column prop="startTime" label="活动时间" header-align="center" align="center"></el-table-column>
                <el-table-column prop="address" label="活动地点" header-align="center" align="center"></el-table-column>
                <el-table-column prop="organizer" label="组织活动机构或个人" header-align="center" align="center"></el-table-column>
                <el-table-column prop="cxName" label="残协名称" header-align="center" align="center"></el-table-column>
                <el-table-column label="操作" fixed="right" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small"
                                   @click="lookDetail(scope.row.id,scope.row.taskType)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="total"
                           layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
                           @current-change="pageCurrentChangeHandle">
            </el-pagination>
        </div>
        <condition-detail v-if="OpenViewAssociation" ref="ViewAssociation"></condition-detail>
    </el-card>
</template>

<script>
    import mixinViewModule from "@/mixins/view-module";
    import conditionDetail from './detail';
    export default {
        mixins: [mixinViewModule],
        components: {
            conditionDetail
        },
        data() {
            return {
                mixinViewModuleOptions: {
                    getDataListURL: "/activity/list",
                    getDataListIsPage: true,
                    createdIsNeed: true,
                },
                daterange: null,
                dataForm: {
                    name: "",
                    area: JSON.parse(localStorage.getItem('org')).area || ''
                },
                OpenViewAssociation: false,
            };
        },
        watch: {
            daterange(val) {
                if (val == null) {
                    this.dataForm.startDate = null;
                    this.dataForm.endDate = null;
                } else {
                    this.dataForm.startDate = val[0];
                    this.dataForm.endDate = val[1];
                }
            },
        },
        methods: {
            lookDetail(id, taskType) {
                //查看详情
                this.OpenViewAssociation = true;
                this.$nextTick(() => {
                    this.$refs.ViewAssociation.init(id,taskType);
                });
            },
        },
    };
</script>
